/**
 * MultilineEditUIStrings.ts
 * 
 * Defines UI strings used in the MultilineEdit component.
 */

/*! Copyright Jon Verrier 2025 */

export enum EMultilineEditUIStrings {

   kMessageTextPrompt = "Ctrl+Enter to confirm or Esc to cancel.",
};


